// src/pages/message-center/utils/shiftTypeIcon.js
import { Clock, Sun, Moon } from 'lucide-react';

export const getShiftTypeIcon = (name = '') => {
  const lower = name.toLowerCase();
  if (lower.includes('day')) return Sun;
  if (lower.includes('night')) return Moon;
  return Clock;
};
